import { AUTOJERRY_BASE_URL, AUTOJERRY_COMPANY_ID, AUTOJERRY_EMBED_URL } from 'lib/autojerry/constants';

// Fallback values used when live data cannot be fetched.
// Live source: AUTOJERRY_EMBED_URL

export const autojerryConfig = {
  companyId: AUTOJERRY_COMPANY_ID,
  rating: 4.8,
  reviewCount: 299,
  fallbackDataDate: '1.9.2026',
  profileUrl: `${AUTOJERRY_BASE_URL}/autokorjaamo/jyvaskyla/huoltoykkoset/`,
  embedUrl: AUTOJERRY_EMBED_URL,
  sourceUrl: AUTOJERRY_BASE_URL,
  sourceLabel: 'AutoJerry',
} as const;
